(function Index($, Adzuki)
{
	"use strict";
	var $calendar_container;

	$(document).ready(function documentReady()
	{
		Adzuki.onload('main/mobileIndex', function onload()
		{
			var calendar_view  = Cookies.get('homepage_calendar_view') || '';

			// notification center
			$('.erez-home-notifications').click(function notificationCenterLinks() {
				if ($(this).data("link") !== '' && $(this).data("link") !== undefined) {
					document.location = $(this).data('link');
				}
			});

			// dashboard calendar
			$calendar_container = $(".homepage-calendar");

			if (calendar_view === '' || calendar_view === 'calendar') {
				initCalendar(true);
			} else {
				initCalendar(false);
			}

			$calendar_container.on('click', '.calendar-next-month, .calendar-prev-month', function changeMonth() {
				var date = reformatDate($(this).data('date'));
				Adzuki.QTip.hideAll();
				loadCalendar(date.day, date.month, date.year, true);
			});

			$calendar_container.on('click', '.calendar-thismonth', function thisMonthClick() {
				Adzuki.QTip.hideAll();
				initCalendar(true);

				Cookies.set('homepage_calendar_view', 'calendar');
			});

			$calendar_container.on('click', '.month-title', function monthClick() {
				document.location = Adzuki.base_uri + '/CalendarSearchIndex/index/' + $(this).data("month") + '/' + $(this).data("year");
			});

			$calendar_container.on('click', '.calendar-date', function calendarDateClick() {
				Adzuki.QTip.createOverlay();
			});

			$calendar_container.on('click', '.list-view', function calendarListViewClick(e) {
				e.preventDefault();
				Adzuki.QTip.hideAll();
				initCalendar(false);

				Cookies.set('homepage_calendar_view', 'list');
			});

			$calendar_container.on('click', '.calendar-view', function calendarCalendarViewClick(e) {
				e.preventDefault();
				Adzuki.QTip.hideAll();
				initCalendar(true);

				Cookies.set('homepage_calendar_view', 'calendar');
			});
		});
	});

	// functions here

	/** dashboard calendar */
	function initCalendar(calendar) {
		var date  = new Date(),
			month = date.getMonth(); // 0-indexed

		loadCalendar(date.getDate(), ++month, date.getFullYear(), calendar);
	}

	function loadCalendar(day, month, year, calendarFormat) {
		var url = '';

		if (calendarFormat === true) {
			url = '/CalendarSearchIndex/homepageCalendar/' + day + '/' + month + '/' + year;
		} else {
			url = '/CalendarSearchIndex/homepageListCalendar/' + day + '/' + month + '/' + year;
		}

		Adzuki.Ajax.get(url)
		.then(function loadCalendarSuccess(response) {
			if (!response.length) {
				throw new Error('operation failed');
			}

			$('.homepage-calendar').html(response);

			$('.calendar-date').click(function showDayEvents() {
				var $self   = $(this),
					daydate = $self.data('daydate'),
					date    = moment(daydate).format('MM/DD/YYYY'),
					$modal  = $(".modal");

					// $modal.addClass('wide');
					$modal.find('.modal-body').text('Loading events for ' + date + '...');

					Adzuki.Ajax.get('/CalendarSearchIndex/eventsByDate/' + daydate)
						.then(function _showExcursions(html) {
							$modal.find('.modal-body').html(html);
							$modal.find('[data-toggle^="tooltip"]').tooltip();
					});

					$modal.find('.modal-title').text('Events for ' + date);
					$modal.on('hidden.bs.modal', function _restoreModal() {
						$modal.removeClass('wide').off('hidden.bs.modal');
					}).modal('show');
			});
		})
		.catch(function error(err) {
			console.log(err);
		});
	}

	function reformatDate(dateString) {
		var date = dateString.split('-');

		return {
			day  : date[2],
			month: date[1],
			year : date[0],
		};
	}

}(jQuery, window.Adzuki || {}));